import React from "react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";

export function StatusModule({
  t,
  isMobile,
  hasXKey,
  cameras,
  loadingCameras,
  loadCameras
}) {
  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
      
      {/* Status Header - Enhanced */}
      <Card className="panel lightCard" style={{
        border: '1px solid #e5e7eb',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <CardContent style={{padding: '20px'}}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            paddingBottom: '12px',
            borderBottom: '2px solid #f59e0b'
          }}>
            <span style={{fontSize: '28px'}}>📈</span>
            <div>
              <div className="panel-title darktxt" style={{fontSize: '18px', marginBottom: '4px'}}>
                {t('status_dashboard_title')}
              </div>
              <div style={{fontSize: '12px', color: '#6b7280'}}>
                {t('status_dashboard_subtitle')}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Status Cards Grid - Enhanced */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '16px'
      }}>
        
        {/* Status Card 1 - System Online */}
        <Card style={{
          padding: '0',
          background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(34, 197, 94, 0.05) 100%)',
          border: '2px solid rgba(34, 197, 94, 0.3)',
          borderRadius: '12px',
          boxShadow: '0 2px 6px rgba(34, 197, 94, 0.2)',
          overflow: 'hidden'
        }}>
          <CardContent style={{padding: '20px'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px'}}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                backgroundColor: '#22c55e',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px'
              }}>
                🟢
              </div>
              <div>
                <strong className="darktxt" style={{fontSize: '16px'}}>
                  {t('status_system_online')}
                </strong>
                <div style={{fontSize: '11px', color: '#059669', marginTop: '2px', fontWeight: '500'}}>
                  {t('all_systems_ready')}
                </div>
              </div>
            </div>
            <div className="small" style={{color: '#6b7280', lineHeight: '1.4'}}>
              {t('status_system_online_desc')}
            </div>
          </CardContent>
        </Card>

        {/* Status Card 2 - Verkada API */}
        <Card style={{
          padding: '0',
          background: hasXKey 
            ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(59, 130, 246, 0.05) 100%)'
            : 'linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(245, 158, 11, 0.05) 100%)',
          border: hasXKey 
            ? '2px solid rgba(59, 130, 246, 0.3)'
            : '2px solid rgba(245, 158, 11, 0.3)',
          borderRadius: '12px',
          boxShadow: hasXKey 
            ? '0 2px 6px rgba(59, 130, 246, 0.2)'
            : '0 2px 6px rgba(245, 158, 11, 0.2)',
          overflow: 'hidden'
        }}>
          <CardContent style={{padding: '20px'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px'}}>
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                backgroundColor: hasXKey ? '#3b82f6' : '#f59e0b',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px'
              }}>
                {hasXKey ? '📡' : '⚠️'}
              </div>
              <div>
                <strong className="darktxt" style={{fontSize: '16px'}}>
                  {t('status_verkada_api')}
                </strong>
                <div style={{
                  fontSize: '11px',
                  color: hasXKey ? '#2563eb' : '#d97706',
                  marginTop: '2px',
                  fontWeight: '500'
                }}>
                  {hasXKey ? 'Verbunden' : 'Nicht konfiguriert'}
                </div>
              </div>
            </div>
            <div className="small" style={{color: '#6b7280', lineHeight: '1.4'}}>
              {hasXKey ? t('status_verkada_connected') : t('status_verkada_not_configured')}
            </div>
          </CardContent>
        </Card>

      </div>

      {/* Camera Overview - Enhanced */}
      <Card className="panel lightCard" style={{
        border: '1px solid #e5e7eb',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <CardContent style={{padding: '20px'}}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px',
            paddingBottom: '12px',
            borderBottom: '2px solid #8b5cf6'
          }}>
            <div style={{display: 'flex', alignItems: 'center', gap: '10px', flex: 1}}>
              <span style={{fontSize: '24px'}}>📹</span>
              <div style={{flex: 1}}>
                <div className="panel-title darktxt" style={{fontSize: '16px', marginBottom: '8px'}}>
                  {t('status_cameras_title')}
                </div>
                {cameras.length > 0 && (
                  <div style={{
                    display: 'flex',
                    gap: '12px',
                    flexWrap: 'wrap'
                  }}>
                    {/* Total Cameras */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '8px 16px',
                      backgroundColor: '#f1f5f9',
                      borderRadius: '8px',
                      border: '2px solid #64748b'
                    }}>
                      <span style={{fontSize: '13px', color: '#475569', fontWeight: '500'}}>Gesamt</span>
                      <span style={{fontSize: '24px', fontWeight: 'bold', color: '#1e293b'}}>
                        {cameras.length}
                      </span>
                    </div>
                    
                    {/* Online Cameras */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '8px 16px',
                      backgroundColor: '#dcfce7',
                      borderRadius: '8px',
                      border: '2px solid #22c55e'
                    }}>
                      <span style={{fontSize: '13px', color: '#15803d', fontWeight: '500'}}>● Online</span>
                      <span style={{fontSize: '24px', fontWeight: 'bold', color: '#16a34a'}}>
                        {cameras.filter(c => c.status === 'Live').length}
                      </span>
                    </div>
                    
                    {/* Offline Cameras */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '8px 16px',
                      backgroundColor: '#fee2e2',
                      borderRadius: '8px',
                      border: '2px solid #ef4444'
                    }}>
                      <span style={{fontSize: '13px', color: '#991b1b', fontWeight: '500'}}>○ Offline</span>
                      <span style={{fontSize: '24px', fontWeight: 'bold', color: '#dc2626'}}>
                        {cameras.filter(c => c.status !== 'Live').length}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <Button 
              onClick={() => loadCameras(true)} 
              disabled={loadingCameras || !hasXKey}
              style={{
                backgroundColor: loadingCameras || !hasXKey ? '#e5e7eb' : '#8b5cf6',
                color: loadingCameras || !hasXKey ? '#9ca3af' : '#fff',
                fontWeight: '600',
                padding: '10px 18px',
                fontSize: '13px',
                border: 'none',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              {loadingCameras ? '⏳ ' + t('status_cameras_loading') : `🔄 ${t('status_cameras_refresh')}`}
            </Button>
          </div>

          {/* Warning/Info Messages */}
          {!hasXKey && (
            <div style={{
              backgroundColor: '#fef3c7',
              padding: '16px',
              borderRadius: '10px',
              border: '2px solid #fbbf24',
              textAlign: 'center',
              marginBottom: '16px'
            }}>
              <div style={{fontSize: '32px', marginBottom: '8px'}}>⚠️</div>
              <div style={{fontSize: '14px', fontWeight: '600', color: '#92400e', marginBottom: '4px'}}>
                API-Schlüssel erforderlich
              </div>
              <div className="small" style={{color: '#78350f'}}>
                {t('status_cameras_api_key_required')}
              </div>
            </div>
          )}

          {hasXKey && cameras.length === 0 && !loadingCameras && (
            <div style={{
              backgroundColor: '#f3f4f6',
              padding: '40px 20px',
              borderRadius: '10px',
              border: '2px dashed #d1d5db',
              textAlign: 'center'
            }}>
              <div style={{fontSize: '48px', marginBottom: '12px'}}>📹</div>
              <div style={{fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '6px'}}>
                {t('no_cameras_loaded')}
              </div>
              <div className="small" style={{color: '#6b7280'}}>
                {t('status_cameras_none_loaded')}
              </div>
            </div>
          )}

          {/* Camera Grid */}
          {cameras.length > 0 && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(340px, 1fr))',
              gap: '16px'
            }}>
              {cameras.map((camera, idx) => {
                const isOnline = camera.status === 'Live';
                const isUpToDate = camera.firmware === 'Up to date' || camera.firmware?.toLowerCase().includes('up to date');
                
                return (
                  <div key={idx} style={{
                    padding: '16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '12px',
                    backgroundColor: '#fff',
                    borderLeftColor: isOnline ? '#22c55e' : '#ef4444',
                    borderLeftWidth: '4px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                  >
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '12px'}}>
                      <div style={{flex: 1}}>
                        <div style={{
                          fontWeight: '700',
                          fontSize: '15px',
                          color: '#111827',
                          marginBottom: '4px'
                        }}>
                          {camera.name}
                        </div>
                        <div className="small" style={{color: '#6b7280', lineHeight: '1.4'}}>
                          📍 {camera.site} • {camera.model}
                        </div>
                      </div>
                      
                      {/* Status Badge */}
                      <div style={{
                        padding: '4px 10px',
                        borderRadius: '16px',
                        fontSize: '11px',
                        fontWeight: '600',
                        backgroundColor: isOnline ? '#dcfce7' : '#fee2e2',
                        color: isOnline ? '#16a34a' : '#dc2626',
                        marginLeft: '8px',
                        whiteSpace: 'nowrap'
                      }}>
                        {isOnline ? '● ' : '○ '}{camera.status}
                      </div>
                    </div>

                    {/* Camera Thumbnail */}
                    {camera.thumbnail && (
                      <div style={{
                        width: '100%',
                        height: '140px',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        marginBottom: '12px',
                        border: '1px solid #e5e7eb',
                        backgroundColor: '#f9fafb'
                      }}>
                        <img 
                          src={camera.thumbnail}
                          alt={`${camera.name} thumbnail`}
                          style={{
                            width: '100%',
                            height: '100%', 
                            objectFit: 'cover'
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      </div>
                    )}
                    
                    {/* Camera Details */}
                    <div className="small" style={{
                      lineHeight: '1.6',
                      marginBottom: '12px',
                      padding: '10px',
                      backgroundColor: '#f9fafb',
                      borderRadius: '8px'
                    }}>
                      <div style={{marginBottom: '4px'}}>
                        <strong>📍 {t('status_camera_location')}:</strong> {camera.location || t('status_camera_not_specified')}
                      </div>
                      <div style={{marginBottom: '4px'}}>
                        <strong>🔌 IP:</strong> {camera.local_ip || 'N/A'} • <strong>Serial:</strong> {camera.serial}
                      </div>
                      <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                        <strong>💾 {t('status_camera_firmware')}:</strong>
                        <span style={{
                          display: 'inline-block',
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          backgroundColor: isUpToDate ? '#22c55e' : '#ef4444',
                          marginLeft: '4px'
                        }}></span>
                        <span style={{fontSize: '11px', color: isUpToDate ? '#16a34a' : '#dc2626', fontWeight: '500'}}>
                          {isUpToDate ? t('status_camera_firmware_current') : t('status_camera_firmware_outdated')}
                        </span>
                      </div>
                    </div>
                    
                    {/* Feature Tags */}
                    <div style={{display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                      {camera.people_history_enabled && (
                        <span style={{
                          padding: '4px 10px',
                          borderRadius: '12px',
                          fontSize: '11px',
                          fontWeight: '600',
                          backgroundColor: '#dbeafe',
                          color: '#1e40af',
                          border: '1px solid #93c5fd'
                        }}>
                          👥 People
                        </span>
                      )}
                      {camera.vehicle_history_enabled && (
                        <span style={{
                          padding: '4px 10px',
                          borderRadius: '12px',
                          fontSize: '11px',
                          fontWeight: '600',
                          backgroundColor: '#f3e8ff',
                          color: '#6b21a8',
                          border: '1px solid #d8b4fe'
                        }}>
                          🚗 Vehicle
                        </span>
                      )}
                      {camera.cloud_retention > 0 && (
                        <span style={{
                          padding: '4px 10px',
                          borderRadius: '12px',
                          fontSize: '11px',
                          fontWeight: '600',
                          backgroundColor: '#dcfce7',
                          color: '#15803d',
                          border: '1px solid #86efac'
                        }}>
                          ☁️ {camera.cloud_retention}d
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

        </CardContent>
      </Card>
    </div>
  );
}
